<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content class="py-2">
  <p>{{data.message}}</p>
</div>
<div class="flex justify-end items-center pt-3" mat-dialog-actions>
  <button mat-button (click)="onNoClick()"  cdkFocusInitial>Cerrar</button>
</div>